import React from 'react';
import loadable from '@loadable/component';
import { SingleDatePickerFallback } from './SingleDatePickerFallback';

import '../../../static/scss/components/reactDatesPicker.scss';

const SingleDatePicker = loadable(() =>
  import(/* webpackChunkName: "component-single-date-picker" */ 'react-dates/lib/components/SingleDatePicker')
);

const LazySingleDatePicker = props => (
  <SingleDatePicker {...props} fallback={<SingleDatePickerFallback />} />
);

export default LazySingleDatePicker;
